export default {
    state: {
        all: [],
        filtered: [],
        selectedSubsidiary: []
    },
    actions: {
        async loadSubsidiaries({ commit }, clientID) {
            await axios.get(`/api/clients/${clientID}/subsidiaries`).then(subsidiaries => {
                commit('setSubsidiaries', subsidiaries)
            }).catch(response => {
                console.error(response);
            });
        },

        async loadProject({ commit }, projectID) {
            await axios.get(`/api/project/${projectID}`).then(project => {
                commit('setSelectedProject', project.data)
            }).catch(response => {
                console.error(response);
            });
        }
    },
    mutations: {
        setSubsidiaries(state, subsidiaries) {
            state.all = subsidiaries.data
            state.filtered = subsidiaries.data
        },
    }
};